import { CollabValueFields } from "@contracts/collab";

/** Global default when a per-customer amount is not provided. Also used server-side via collabSettings.hotelShrpaCreatorCompensation. */
export const DEFAULT_HOTEL_COVERAGE_FROM_SHRPA = 250;

export default {
  // Kept for backward-compatible imports; prefer passing an explicit amount into the calculators.
  HotelCoverageFromShrpa: DEFAULT_HOTEL_COVERAGE_FROM_SHRPA,

  overallCollabValue(collabInput: CollabValueFields, creatorCurrentRate: number, other: number, hotelCoverageFromShrpa: number = DEFAULT_HOTEL_COVERAGE_FROM_SHRPA): number {
    return this.totalPaymentFromShrpa(collabInput, creatorCurrentRate, other, hotelCoverageFromShrpa) + this.estimatedActivityValue(collabInput) + this.estimatedLodgingValue(collabInput);
  },

  totalPaymentFromShrpa(collabInput: CollabValueFields, creatorCurrentRate: number, other: number, hotelCoverageFromShrpa: number = DEFAULT_HOTEL_COVERAGE_FROM_SHRPA): number {
    let total = creatorCurrentRate + other;
    // Note: Showing this even if they don't need a hotel (since they haven't applied yet and set that field)
    if (collabInput.hotelNightsCovered === 0) total += hotelCoverageFromShrpa;
    return total;
  },

  estimatedActivityValue(collabInput: CollabValueFields): number {
    // Logic is also in CollabInputValidator (and the inverse in CreateCollab)
    if (collabInput.requestingBigTicketItems === true || collabInput.compedActivitiesTags.length > 0) return collabInput.compedActivitiesEstimatedValue ?? 0;
    return 0;
  },
  estimatedLodgingValue(collabInput: CollabValueFields): number {
    if (collabInput.hotelNightsCovered > 0) return collabInput.hotelEstimatedValue ?? 0;
    return 0;
  },
};
